import { render } from "./PaymentSelect.vue?vue&type=template&id=0799e182&scoped=true&ts=true"
import script from "./PaymentSelect.vue?vue&type=script&lang=ts"
export * from "./PaymentSelect.vue?vue&type=script&lang=ts"

import "./PaymentSelect.vue?vue&type=style&index=0&id=0799e182&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0799e182"]])

export default __exports__